import React, { useEffect, useMemo, useState } from "react";
import { Box, IconButton } from "@mui/material";
import apiClient from "../services/apiClient";
import { useDispatch, useSelector } from "react-redux";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MdDelete } from "react-icons/md";

import SearchIcon from "@mui/icons-material/Search";
import PageLoader from "../components/Loading/PageLoader";
import CustomInputBox from "../components/Form/CustomInputBox";
import { setModal } from "../features/modal/ModalSlice";

const ErrorLogs = () => {
  const [numberDetails, setNumberDetails] = useState([]);
  const [filter, setFilter] = useState({
    search: "",
    assigned_phone_status: "",
    page: 1,
    pageSize: 10,
  });

  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(true);

  const userInfo = useSelector((state) => state?.userInfo?.user);
  const dispatch = useDispatch();

  useEffect(() => {
    handleFetchAllocatedExtension();
  }, [filter]);

  const handleFetchAllocatedExtension = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(`/error_logs/company/${userInfo?.company_id}`);

      console.log(response?.data);

      setNumberDetails(response?.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "error",
        header: "Error",
      },
      {
        accessorKey: "error_details",
        header: "Message",
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data: numberDetails,
    enableColumnOrdering: true,
    enableRowSelection: true,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableRowActions: true,
    enablePagination: false,
    positionActionsColumn: "last",
    renderRowActions: () => (
      <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
        <IconButton disabled>
          <MdDelete />
        </IconButton>
      </Box>
    ),
    muiTableHeadCellProps: {
      sx: {
        backgroundColor: "#F5F6F8",
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
      },
    },
  });

  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };

  const handleConfigureNumberPopUp = (data = null) => {
    dispatch(setModal({ type: "CONFIGURE_NUMBER", data }));
  };

  return (
    <>
      {loading && <PageLoader text="Loading Error Logs" />}

      <>
        <div className="pageTitle1 p-5">
          <h3>Error Logs</h3>
          <p>{numberDetails?.length} Available</p>
        </div>

        <Box sx={{ padding: 2 }}>
          <div className="d-flex justify-content-between">
            <div className="w-50">
              <CustomInputBox
                icon={SearchIcon}
                placeholder="Search Number or Extension"
                type="text"
                backgroundColor={"#FFFFFF"}
                borderRadius="8px"
              />
            </div>

            <div className="d-flex justify-content-end gap-3 mb-4">
              {/* <CustomButton
                text={(showFilter ? "Hide" : "Show") + " Filter"}
                color="secondary"
                iconPosition="left"
                icon={showFilter ? <MdFilterListOff /> : <MdFilterList />}
                onClick={handleShowFilter}
              />

              <CustomButton text={"Configure"} onClick={() => handleConfigureNumberPopUp()} /> */}
            </div>
          </div>

          {/* {showFilter && (
            <div className="d-flex justify-content-start gap-3 mb-4">
              <Autocomplete
                disablePortal
                options={[]}
                sx={{ width: 200, backgroundColor: "white", borderRadius: "8px" }}
                size="small"
                renderInput={(params) => <TextField {...params} label="Extension" />}
              />

              <Autocomplete
                disablePortal
                options={["assigned", "not-assigned"]}
                value={filter?.assigned_phone_status}
                onChange={(event, newValue) =>
                  setFilter((prev) => ({ ...prev, assigned_phone_status: newValue || "" }))
                }
                name="assigned_phone_status"
                sx={{ width: 200, backgroundColor: "white", borderRadius: "8px" }}
                size="small"
                renderInput={(params) => <TextField {...params} label="Status" />}
              />

              <CustomButton text={"Reset"} variant="text" color="inherit" />
            </div>
          )} */}

          <MaterialReactTable table={table} />
        </Box>
      </>
    </>
  );
};

export default ErrorLogs;
